import angular from 'angular';
import moment from 'moment-timezone';
import { find, get, reduce } from 'lodash';

const FINANCING_OPTIONS = [
  {
    label: 'Cash',
    value: 'cash',
  }, {
    label: 'Loan',
    value: 'loan',
    default: true,
  }
];

const AGENT_STATUS_OPTIONS = [
  {
    label: 'Yes',
    value: 'yes',
  }, {
    label: 'No',
    value: 'no',
    default: true,
  },
  {
    label: "I'm an agent",
    value: 'agent',
  },
];

class CheckoutManager {
  // NOT injectable - params are passed via the checkoutManager factory
  constructor(rootScope, localStorageService, weekdayWorkCalendar, RESERVATION_PRICE_CENTS) {
    this.weekdayWorkCalendar = weekdayWorkCalendar;
    this.localStorageService = localStorageService;
    this.RESERVATION_PRICE_CENTS = RESERVATION_PRICE_CENTS;

    this.FINANCING_OPTIONS = FINANCING_OPTIONS;
    this.AGENT_STATUS_OPTIONS = AGENT_STATUS_OPTIONS;

    this.listing = null;
    this.totalPriceCents = null;

    this.options = this._loadOptionsFromLocalStorage();
    this._saveOptionsToLocalStorage();

    // Deep watch options, so no matter where they are changed, the checkout
    // data and price stay up to date
    rootScope.$watch(() => this.options, () => {
      this._saveOptionsToLocalStorage();
      this._updateTotalPrice();
    }, true);
  }

  setListing(listing) {
    this.listing = listing;
    this.localStorageService.set('CheckoutManager.listing', this.options);
    this._updateTotalPrice();
  }

  _loadOptionsFromLocalStorage() {
    let lsOptions = this.localStorageService.get('CheckoutManager.options') || {};
    return {
      financing_type:
        find(FINANCING_OPTIONS, { value: get(lsOptions, ['financing', 'value']) }) ||
        find(FINANCING_OPTIONS, 'default'),
      agent_status:
        find(AGENT_STATUS_OPTIONS, { value: get(lsOptions, ['agent', 'value']) }) ||
        find(AGENT_STATUS_OPTIONS, 'default'),
      agent_name: lsOptions.agent_name || '',
      client_name: lsOptions.client_name || '',
    };
  }

  _saveOptionsToLocalStorage() {
    this.localStorageService.set('CheckoutManager.options', this.options);
  }

  _futureWorkday(days) {
    return this.weekdayWorkCalendar.workdaysAfter(moment(), days);
  }

  _updateTotalPrice() {
    this.totalPriceCents =
      this.listing.price_cents +
      reduce(this.options, (acc, option) => {
        return acc + (option.priceCents || 0);
      }, 0);
  }
}

module.exports = angular.module('common.services.checkout-manager', [])
.factory('checkoutManager', function($rootScope, localStorageService,
                                     weekdayWorkCalendar, RESERVATION_PRICE_CENTS) {
  return new CheckoutManager($rootScope, localStorageService,
                             weekdayWorkCalendar, RESERVATION_PRICE_CENTS);
})
.name;



/** WEBPACK FOOTER **
 ** ./javascripts/market/services/checkout-manager.js
 **/